import type { PapersBannerSize, PapersBannerVariant } from './PapersBanner'

// Papers AI banner config for x.writefull.com.
// Audience: people using the free quick tools (paraphraser, title/abstract
// generators) who keep hitting limits — nudge them toward the full workspace.
//
// Copy and height are FIXED to the winners of the prior tests: variant
// `cta_next_step` at the `tall` size. The live A/B test is now on banner POSITION
// (static vs sticky), handled inside PapersBanner. The CTA link carries
// `ref=x_writefull_com&var=cta_next_step&size=tall&pos=<arm>`.
export const PAPERS_BANNER: {
  siteRef: string
  ctaHref: string
  variant: PapersBannerVariant
  size: PapersBannerSize
} = {
  siteRef: 'x_writefull_com',
  ctaHref: 'https://papers.ai/',
  variant: {
    id: 'cta_next_step',
    headline: 'Hit a limit? Step up',
    bullets: ['Draft entire papers', 'Bring any premium model', 'Free to start'],
    ctaLabel: 'Try Papers AI',
  },
  size: { id: 'tall', minHeight: '132px', padY: '32px' },
}
